import React, { useEffect } from "react";
import { BrowserRouter as Router, Switch, Route, Redirect } from 'react-router-dom';
import { Provider } from 'react-redux';
import { store } from './store/store';
import { setCredentials } from './features/auth/authSlice';
import { authStorage } from './utils/authStorage';
import SecurityWrapper from './components/SecurityWrapper';
import PrivateRoute from './components/PrivateRoute';
import Login from "./pages/login";
import InvestorDashboard from "./pages/investor-dashboard";
import LPDashboard from "./pages/lp-dashboard";
import NTCDashboard from "./pages/ntc-dashboard";
import Upcoming from "./pages/upcoming";
import AllocationSheet from "./pages/allocation-sheet";
import Active from "./pages/active";
import InvestedProjects from "./pages/invested";
import OngoingProjects from "./pages/ongoing";
import CompletedProjects from "./pages/completed";
import UnreleasedProjects from "./pages/unreleased";
import Documents from "./pages/documents";

function AppContent() {
  useEffect(() => {
    const data = authStorage.getLoginData();
    if (data && typeof data === 'object') {
      store.dispatch(setCredentials(data));
    }
  }, []);

  return (
    <Router>
      <Switch>
        <Route exact path="/" component={Login} />
        <Route exact path="/login" component={Login} />
        <PrivateRoute exact path="/investor-dashboard" component={InvestorDashboard} />
        <PrivateRoute exact path="/lp-dashboard" component={LPDashboard} />
        <PrivateRoute exact path="/ntc-dashboard" component={NTCDashboard} />
        <PrivateRoute exact path="/upcoming" component={Upcoming} />
        <PrivateRoute exact path="/allocation-sheet" component={AllocationSheet} />
        <PrivateRoute exact path="/active" component={Active} />
        <PrivateRoute exact path="/invested" component={InvestedProjects} />
        <PrivateRoute exact path="/ongoing" component={OngoingProjects} />
        <PrivateRoute exact path="/completed" component={CompletedProjects} />
        <PrivateRoute exact path="/unreleased" component={UnreleasedProjects} />
        <PrivateRoute exact path="/documents" component={Documents} />
        <Redirect from="*" to="/" />
      </Switch>
    </Router>
  );
}

function App() {
  return (
    <Provider store={store}>
      <SecurityWrapper>
        <AppContent />
      </SecurityWrapper>
    </Provider>
  );
}

export default App;
